import { render, staticRenderFns } from "./WorkIconCustomer.vue?vue&type=template&id=96cb9be2"
import script from "./WorkIconCustomer.vue?vue&type=script&lang=js"
export * from "./WorkIconCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports